export default "__VITE_ASSET__0b9ede57__"